import { get } from "lodash";

export const QUESTION_TYPES = {
  SHORT_ANSWER: "SHORT_ANSWER",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  CHECKBOXES: "CHECKBOXES",
};

export const TYPE_WITH_ANSWERS = new Set(["MULTIPLE_CHOICE", "CHECKBOXES"]);

export const QUESTION_TYPES_TITLES = {
  SHORT_ANSWER: "Short Answer",
  MULTIPLE_CHOICE: "Multiple Choice",
  CHECKBOXES: "Checkboxes",
};

export const QUESTION_TYPES_OPTIONS = Object.keys(QUESTION_TYPES).map((key) => ({
  value: get(QUESTION_TYPES, key),
  label: get(QUESTION_TYPES_TITLES, key),
}));

export const lateTypes: any = {
  OVER_BREAK_PM: "Over afternoon break",
  OVER_BREAK_AM: "Over morning break",
  LATE_ARRIVE: "Late arrive",
  EARLY_LEAVE: "Early leave",
  ABSENT: "Absent",
};

export const lateTypeOptions: any = [
  {
    value: "EARLY_LEAVE",
    label: lateTypes.EARLY_LEAVE,
  },
  {
    value: "LATE_ARRIVE",
    label: lateTypes.LATE_ARRIVE,
  },
  {
    value: "ABSENT",
    label: lateTypes.ABSENT,
  },
  {
    value: "OVER_BREAK_PM",
    label: lateTypes.OVER_BREAK_PM,
  },
  {
    value: "OVER_BREAK_AM",
    label: lateTypes.OVER_BREAK_AM,
  },
];

export const lateType = {
  CURRENT_MONTH: 'Shu oy',
  LAST_MONTH: "O'tgan oy",
  CURRENT_WEEK: 'Shu hafta',
  LAST_WEEK: "O'tgan Hafta",
  TODAY: 'Bugun',
  MANUAL: "Qo'lda tanlash",
};

export const  lateTypesOptions = [
  {
    value: 'CURRENT_MONTH',
    label: lateType.CURRENT_MONTH,
  },
  {
    value: 'LAST_MONTH',
    label: lateType.LAST_MONTH,
  },
  {
    value: 'CURRENT_WEEK',
    label: lateType.CURRENT_WEEK,
  },
  {
    value: 'LAST_WEEK',
    label: lateType.LAST_WEEK,
  },
  {
    value: 'TODAY',
    label: lateType.TODAY,
  },
  {
    value: 'MANUAL',
    label: lateType.MANUAL,
  },
];


export const weekDays = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

export const PARTNER_ATTACHMENT_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}attachment/v1/attachment`;

export const partnerPhotoUrl = (photoId?: string | null) =>
  photoId ? `${PARTNER_ATTACHMENT_BASE_URL}/download?id=${encodeURIComponent(photoId)}` : undefined;
